<div class="familiar-cta">
  <div class="familiar-cta-container">
    <h2>Registre un nuevo familiar en Signo Médico</h2>
    <p>Haga clic en el botón <strong>Alta familiar a cargo</strong> para agregar a un familiar a nuestra obra social.</p>
    <button (click)="darDeAltaFamiliar()" class="btn-alta" type="button">
      <span class="material-icons">person_add</span>
      Alta Familiar
    </button>
  </div>
</div>